<template>
  <div class="widget">
    <div class="widget-heading">
      <h2 class="textStyle">{{ title }}</h2>
    </div>
    <div class="widget-content">
      <div v-for="item in items" :key="item.key_label" class="caption__item">
        <span v-if="item.key_label">{{ item.key_label }}</span>
        <span v-if="item.class" :class="'caption__label -' + item.class"></span>
        {{ item.label }}
      </div>
    </div>
  </div>
</template>

<script>
import { i18n } from "@/i18n";

export default {
  name: "SortTableCaptionWidgetComponent",
  components: {},
  props: {
    title: {
      type: String,
      required: false,
      default: i18n.global.t("global.caption.title"),
    },
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.caption {
  &__item {
    display: flex;
    margin-bottom: 20px;
  }
  &__label {
    display: block;
    width: 20px;
    min-width: 20px;
    height: 20px;
    border-radius: 5px;
    margin-right: 5px;

    &.-danger {
      background-color: rgba($red, 0.15);
    }
    &.-success {
      background-color: rgba($green, 0.2);
    }
  }
}
</style>
